export default __webpack_public_path__ + "static/media/Logo_HC.2104485a.png";